var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('img',{attrs:{"src":require("@/assets/icons/checkin.svg")},on:{"click":function($event){return _vm.openCheckin()}}}):_c('i',{staticClass:"fas fa-spinner fa-spin icon"})}
var staticRenderFns = []

export { render, staticRenderFns }